import {ICheckoutData} from "../CheckoutData";
import {
  CheckoutRequestHandler,
  ICheckoutPutParams,
  IGetCheckoutShippingOptionsData,
} from "../requestHandlers/CheckoutRequestHandler";

export class ShippingFactory {
  /**
   * Gets all available shipping options for this checkout
   * @param {number} shopId
   * @param {string} checkoutId
   * @returns {Promise<IGetCheckoutShippingOptionsData[]>}
   */
  public static async getShippingOptions(
    shopId: number,
    checkoutId: string,
  ): Promise<IGetCheckoutShippingOptionsData[]> {
    return await CheckoutRequestHandler.getShippingOptions(shopId, checkoutId);
  }

  /**
   * fill existing checkout with shipping data
   * @param {number} shopId
   * @param {string} checkoutId
   * @param {ICheckoutPutParams} payload
   * @returns {Promise<ICheckoutData>}
   */
  public static async setShippingOptions(
    shopId: number,
    checkoutId: string,
    payload: ICheckoutPutParams,
  ): Promise<ICheckoutData> {
    return CheckoutRequestHandler.putParams(shopId, checkoutId, payload);
  }
}
